import React from "react";
import Hero from "../Hero";
import AboutSection from "../Section/AboutSection";
import BrandsSection from "../Section/BrandsSection";
import Banner from "../Section/BannerSection";
import Section from "../Section";
import FeaturesSection from "../Section/FeaturesSection";
import TestimonialSection from "../Section/TestimonialSection";
import BlogSection from "../Section/BlogSection";
import AppointmentSection from "../Section/AppointmentSection";
import FaqSection from "../Section/FaqSection";
import AwardSection from "../Section/AwardSection";
import DepartmentSection from "../Section/DepartmentSection";
import "./Home.scss";
import { pageTitle } from "../../helpers/PageTitle";
const featureListData = [
  {
    iconSrc: "/images/home_1/Medical Expertise.svg",
    title: "Pathophysiology First",
    subTitle:
      "Understanding disease pathophysiology enables targeted treatments and better patient outcomes.",
  },
  {
    iconSrc: "/images/home_1/Authentic & Trusted Medicines.svg",
    title: "Safety over exaggeration",
    subTitle:
      "Patient safety comes first. We rely on clinical evidence and transparent communication to build trust.",
  },
  {
    iconSrc: "/images/home_1/Committed Healthcare Solutions.svg",
    title: "Long-term outcomes over short-term claims",
    subTitle: `Sustainable healthcare means lasting improvements and quality of life, not just quick results.`,
  },
];
const brandData = [
  { imgUrl: "images/brand_1.png", imgAlt: "Brand" },
  { imgUrl: "images/brand_2.png", imgAlt: "Brand" },
  { imgUrl: "images/brand_3.png", imgAlt: "Brand" },
  { imgUrl: "images/brand_4.png", imgAlt: "Brand" },
  { imgUrl: "images/brand_5.png", imgAlt: "Brand" },
  { imgUrl: "images/brand_6.png", imgAlt: "Brand" },
  { imgUrl: "images/brand_7.png", imgAlt: "Brand" },
  { imgUrl: "images/brand_8.png", imgAlt: "Brand" },
];
const faqData = [
  {
    title: "What does Celbion Healthcare specialize in?",
    content:
      "Celbion Healthcare is a pharmaceutical company focused on developing and delivering high-quality, affordable medicines to improve patient health and well-being. Our portfolio includes a range of products designed to meet modern healthcare needs.",
  },
  {
    title: "Is Celbion Healthcare a research-driven company?",
    content:
      "Yes, we are committed to continuous research and innovation. Our team works on developing effective and safe formulations backed by scientific evidence and evolving healthcare standards.",
  },
  {
    title: "Where is Celbion Healthcare located?",
    content:
      "Celbion Healthcare is based in India. For detailed contact information, please visit our “Contact Us” section or reach out via email/phone provided on the website.",
  },
  {
    title: "Are Celbion Healthcare products safe and approved?",
    content:
      "Yes, all our products are manufactured in compliance with regulatory guidelines and quality standards such as GMP (Good Manufacturing Practices), ensuring safety, efficacy, and consistency.",
  },
  {
    title: "What quality standards do you follow?",
    content:
      "We adhere to stringent national and international quality standards, including WHO-GMP guidelines, ensuring that every product meets high safety and quality benchmarks.",
  },
  {
    title: "Do your medicines have side effects?",
    content:
      "Like all medicines, our products may have potential side effects depending on individual conditions. We strongly recommend using medicines only as prescribed by a qualified healthcare professional.",
  },
];
const blogData = [
  {
    thumbUrl: "images/home_1/post_1.jpg",
  },
  {
    thumbUrl: "images/home_1/post_1.jpg",
  },
  {
    thumbUrl: "images/home_1/post_1.jpg",
  },
];
const BramdData = [
  {
    thumbUrl: "images/home_1/brandimage.png",
  },
  {
    thumbUrl: "images/home_1/brandimage.png",
  },
  {
    thumbUrl: "images/home_1/brandimage.png",
  },
];
const awardData = [
  {
    title: "Malcolm Baldrige National Quality Award",
    subTitle:
      "This award recognizes healthcare organizations that have demonstrated excellence in leadership, strategic planning, customer and employee satisfaction, and operational efficiency.",
    iconUrl: "images/icons/award.svg",
  },
  {
    title: "HIMSS Davies Award",
    subTitle:
      "This award recognizes healthcare organizations that have used health information technology to improve patient outcomes and reduce costs.",
    iconUrl: "images/icons/award.svg",
  },
  {
    title: "Healthgrades National’s Best Hospital",
    subTitle:
      "This recognition is given to hospitals that have achieved high ratings for clinical quality and patient safety across multiple specialties and procedures.",
    iconUrl: "images/icons/award.svg",
  },
  {
    title: "Joint Commission Gold Seal of Approval",
    subTitle:
      "This recognition is given to hospitals that have met rigorous standards for patient safety and quality of care.",
    iconUrl: "images/icons/award.svg",
  },
];
const departmentData = [
  {
    title: "Emergency Department",
    iconUrl: "images/home_1/department_icon_1.svg",
    href: "/departments/department-details",
  },
  {
    title: "Pediatric Departement",
    iconUrl: "images/home_1/department_icon_2.svg",
    href: "/departments/department-details",
  },
  {
    title: "Gynecology Department",
    iconUrl: "images/home_1/department_icon_3.svg",
    href: "/departments/department-details",
  },
  {
    title: "Cardiology Department",
    iconUrl: "images/home_1/department_icon_4.svg",
    href: "/departments/department-details",
  },
  {
    title: "Neurology Department",
    iconUrl: "images/home_1/department_icon_5.svg",
    href: "/departments/department-details",
  },
  {
    title: "Psychiatry Department",
    iconUrl: "images/home_1/department_icon_6.svg",
    href: "/departments/department-details",
  },
];

export default function Home() {
  pageTitle("Home");
  return (
    <>
      <Hero
        title="Your Partner in Health and Wellness"
        subTitle="We are committed to providing you with the best medical and healthcare services to help you live healthier and happier."
        bgUrl="/images/home_1/hero_bg.png"
        imgUrl="/images/home_1/hero_img_bg.png"
        videoBtnText="See how we work"
        videoUrl="https://www.youtube.com/watch?v=-Ftg5mSK9LA"
        infoList={[
          {
            title: "Hotline",
            subTitle: "123-456-7890",
            iconUrl: "/images/contact/icon_1.svg",
          },
          {
            title: "Ambulance",
            subTitle: "876-256-876",
            iconUrl: "/images/icons/ambulance.svg",
          },
          {
            title: "Location",
            subTitle: "New York, US",
            iconUrl: "/images/icons/pin.svg",
          },
        ]}
        btnText="Book Now"
        btnUrl="/appointments"
      />
      {/* Start Feature Section */}

      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={185}
        bottomLg={140}
        bottomXl={100}
      >
        <FeaturesSection
          // sectionTitle="WHY CELBION WAS LAUNCHED?"
          data={featureListData}
        />
      </Section>
      {/* Inserted image after FeaturesSection */}
      {/* <div className="celbion-launched-image" style={{ textAlign: 'center', margin: '40px 0' }}>
        <img src="/images/home_1/celbion-bg-img.png" alt="Celbion Launched Design" style={{ maxWidth: '100%', height: 'auto' }} />
      </div> */}
      <div class="badge-container">
        <div class="badges">
          <div
            className="card"
            style={{ "--img": "url('/images/pathophysiology.png')", height: "300px" }}
          >
            <span>Pathophysiology First</span>
          </div>
          <div
            className="card"
            style={{ "--img": "url('/images/safety.png')", height: "300px" }}
          >
            <span>Safety Over Exaggeration</span>
          </div>
          <div
            className="card"
            style={{ "--img": "url('/images/longterm.png')", height: "300px" }}
          >
            <span>Long-term Outcomes</span>
          </div>
        </div>
      </div>
      {/* Start About Section */}
      <Section>
        <AboutSection
          imgUrl="/images/home_1/about.png"
          spiningImgUrl="/images/home_1/about_mini.svg"
          title="About Us"
          subTitle="Celbion Healthcare is a pharmaceutical company focused on developing and delivering safe, effective, and innovative healthcare solutions. The company operates in the field of pharmaceuticals, medicinal chemicals, and healthcare products, aiming to improve patient well-being and quality of life."
          featureList={[
            {
              featureListTitle:
                "ProHealth is a team of experienced medical professionals",
              featureListSubTitle:
                "Celbion Healthcare is a research-driven pharmaceutical company focused on developing innovative, safe, and effective healthcare solutions. The company was founded with the vision of addressing unmet medical needs in areas such as neurology, psychiatry, cognitive disorders, and pain management.",
            },
          ]}
        />
      </Section>
      {/* End About Section */}
      {/* Start Departments Section */}
      <Section topMd={185} topLg={150} topXl={110}>
        <DepartmentSection
          sectionTitle="Departments"
          bgUrl="images/home_1/department_bg.svg"
          data={departmentData}
        />
      </Section>

      {/* End Departments Section */}
      {/* Start Award Section */}
      {/* <Section topMd={185} topLg={140} topXl={100}>
        <AwardSection sectionTitle="Departments" data={awardData} />
      </Section> */}
      {/* End Award Section */}
      {/* Start Testimonial */}
      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        {/* <TestimonialSection
          sectionTitle="Some Reviews"
          sectionTitleDown="Of our clients"
        /> */}
      </Section>
      {/* End Testimonial */}
      {/* Start Banner Section */}
      <Section>
        <Banner
          bgUrl="images/home_1/cta_bg.svg"
          imgUrl="images/home_1/cta_img.png"
          title="Don’t Let Your Health Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced medical professionals today!"
        />
      </Section>
      {/* End Banner Section */}
      {/* Start Blog Section */}
      {/* <Section topMd={190} topLg={145} topXl={105}>
        <BlogSection
          sectionTitle="Our Awards"
          subTitle="Success is shaped through steady progress, shared commitment, and a clear vision. At Celbion Healthcare, our dedicated team works as one to deliver high-quality medicines that enhance quality of life. Through a science-driven and collaborative approach, we address complex healthcare challenges while achieving meaningful milestones in a short span of time. Guided by strong values and social responsibility, we remain committed to serving our nation with trusted, effective, and accessible healthcare solutions."
          data={blogData}
        />
      </Section> */}
      {/* End Blog Section */}
      {/* Start Appointment Section */}
      <Section topMd={190} topLg={145} topXl={105} id="appointment">
        <AppointmentSection
          sectionTitle="Appointment"
          sectionTitleUp="BOOK AN"
          imgUrl="/images/home_1/appointment.jpeg"
        />
      </Section>
      {/* End Appointment Section */}
      {/* Start FAQ Section */}
      <Section topMd={190} topLg={145} topXl={105}>
        <FaqSection
          data={faqData}
          sectionTitle="Usually Asked"
          sectionTitleUp="What People"
        />
      </Section>
      {/* End FAQ Section */}
      {/* Start Brand Section */}
      <Section topMd={190} topLg={145} topXl={105}>
        <BlogSection />
      </Section>
      {/* <Section
        topMd={200}
        topLg={150}
        topXl={110}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <BrandsSection data={brandData} />
      </Section> */}
      {/* End Brand Section */}
    </>
  );
}
